import * as actions from '../actionTypes'

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = { 
    value: true
}

export default function showDiagrams(state = initialState, action) {

    switch(action.type) {

        case actions.SET_SHOW_DIAGRAMS: {

            //console.log('[redux] Setting show diagrams
            return {
                ...state,
                value: action.payload.value
            }
        }

        default:
            return state
    }
}